<template>
  <RequestWizardStep name="Records Type"
    :complete="recordsType === 'Medicare beneficiary claims records'"
  >
    <ContentCard title="Great! Let's make sure we can provide you the records you are requesting.">
      <AlertMessage type="warning" :show="recordsType === 'Medicare Advantage claims records'"
        title="Medicare Advantage Claims Records"
      >
        <p>Please note that the Centers for Medicare and Medicaid Services does not hold
          or have access to Medicare Advantage Plans claim records. Please contact your
          plan directly for that information.
        </p>
        <a target="_blank"
          href="https://www.medicare.gov/claims-appeals/check-the-status-of-a-claim"
        >Click here for additional information on Medicare Advantage Plan claims</a>.
      </AlertMessage>

      <AlertMessage type="warning" :show="recordsType === 'Prescription Drug claims records'"
        title="Prescription Drug Claims Records"
      >
        <p>Please note that the Centers for Medicare and Medicaid Services does not hold
          or have access to Prescription Drug claim records. Please contact your plan
          directly for that information.
        </p>
        <a target="_blank"
          href="https://www.medicare.gov/claims-appeals/check-the-status-of-a-claim"
        >Click here for additional information on prescription drug claims</a>.
      </AlertMessage>

      <AlertMessage type="warning"
        :show="recordsType === 'Social Security Administration documents'"
        title="Social Security Administration Documents"
      >
        <p>Please note that the Centers for Medicare and Medicaid Services does not hold
          or have access to documents related to the Social Security Administration.
        </p>
        <a target="_blank"
          href="https://www.ssa.gov/"
        >Click here for additional information on the Social Security Administration</a>.
      </AlertMessage>

      <AlertMessage type="warning"
        :show="recordsType === 'Medicare Secondary Payer lien information'"
        title="Secondary Payer Lien Information"
      >
        <p>Please note that Medicare Secondary Payer (MSP) lien, subrogation, and workman's
          compensation information cannot be obtained through a FOIA request or a Medicare
          beneficiary claims request.
        </p>
        <a target="_blank"
          href="https://www.cms.gov/Medicare/Coordination-of-Benefits-and-Recovery/Attorney-Services/Attorney-Services"
        >Click here for additional information on MSP</a>.
      </AlertMessage>

      <AlertMessage type="warning"
        :show="recordsType === 'Other Medicare records'"
        title="Other Medicare Records"
      >
        Please note that other Medicare records such as Provider Information, Cost Reports,
        Survey/Certification, and Facility Records should be requested through the
        <a target="_blank"
          href="https://www.foia.gov/request/agency-component/e07b59b9-db3b-4611-898d-23b42f7ead8d/"
        >FOIA.gov website</a>.
      </AlertMessage>

      <RadioButtons
        label="Please select from the following:"
        :options="[
          ...[
            'Medicare beneficiary claims records',
            'Medicare Advantage claims records',
            'Prescription Drug claims records',
            'Social Security Administration documents',
            'Medicare Secondary Payer lien information'
          ].map(o => ({ label: o, value: o })),
          {
            value: 'Other Medicare records',
            label: 'Other Medicare records (Provider Information, Cost Reports,'
              + ' Survey/Certification, Facility Records, etc.)'
          }
        ].map(({ label, value }) => ({
          label: `I am requesting ${label}.`,
          value
        }))"
        v-model="recordsType"
      />
    </ContentCard>
  </RequestWizardStep>
</template>

<script>
import RadioButtons from '@/components/formFields/RadioButtons';
import AlertMessage from '@/components/AlertMessage';
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';

export default {
  components: {
    RadioButtons, AlertMessage, RequestWizardStep
  },

  data: () => ({
    recordsType: null
  })
};
</script>
